<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} tarifa
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Nombre tarifa <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="description" required [autofocus]>
                </div>
                <div class="form-group col-lg-2">
                  <label>Abreviación <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="abbreviation" required>
                </div>
                <!-- <div class="form-group col-lg-2">
                  <label>Fecha inicio</label>
                  <input type="text" class="form-control" formControlName="start_date" id="start_date">
                </div>
                <div class="form-group col-lg-2">
                  <label>Fecha Fin</label>
                  <input type="text" class="form-control" formControlName="end_date" id="end_date">
                </div> -->
                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox float-left">
                    <input type="checkbox" class="custom-control-input" formControlName="is_show" id="is_show">
                    <label class="custom-control-label p-t-3" for="is_show">¿Es activo?</label>
                  </div>
                </div>
              </div>

              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i>
                    Rangos de temporada
                  </p>

                </div>
                <div class="form-group col-lg-8 col-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th class="text-center"></th>
                          <th class="position-relative">Fecha Inicio <span class="required"></span></th>
                          <th class="position-relative">Fecha Fin <span class="required"></span></th>
                          <th>Descripción</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="detail_ranges.length == 0">
                          <tr>
                            <td colspan="2"><span>No se encontraron registros</span></td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail_ranges.length > 0">
                          <tr *ngFor="let item of detail_ranges; let index_ = index">    
                            <td class="text-center">{{index_+1}}</td>                        
                            <td>
                              <input type="text" id="start_date{{index_}}" class="form-control form-control-xs"
                              [value]="item.start_date"  (change)="changeStarDate($event.target, index_)">
                            </td>
                            <td>
                              <input type="text" id="end_date{{index_}}"
                                class="form-control form-control-xs" value="{{item.end_date}}"
                                (change)="changeEndDate($event.target, index_)">
                            </td>
                            <td>
                              <input type="text" id="description{{index_}}" class="form-control form-control-xs"
                                value="{{item.description}}" (keyup)="changeDescription($event.target, index_)">
                            </td>
                            <td>
                              <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                (click)="removeRangeRate(item.id, index_)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                  <a class="btn btn-info btn-sm f-s-12 text-white m-t-10" (click)="addRangeRate()">Agregar rango.
                    <i class="fas fa-arrow-up m-l-5"></i>
                  </a>
                </div>
              </div>

            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
